"use strict";
const startPageShogunDefault = () => {
    console.log('UNTUCKit : Template : PageShogunDefault');
    // loading modules for shogun previews or live shogun pages that aren't set to the homepage
    if (window.location.pathname.includes('previews') || window.location.pathname.includes('pages/untuckit-home')) {
        import(/* webpackChunkName: "trending-now" */ '../modules/TrendingNow').then((mod) => mod.default.init());
        import(/* webpackChunkName: "revealer" */ '../modules/Revealer').then((mod) => mod.default.init());
    }
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPageShogunDefault, { once: true });
}
else {
    startPageShogunDefault();
}
